module.exports = __webpack_public_path__ + "img/nchiin.782aae39.png";